import { Spinner } from '@cimplico/components';
import { useEntriesV2 } from '../../../queries/use-entries';
import { GenericWorksheet, ReconciliationWorksheet } from '../../../types/worksheet';
import EntriesTable from './EntriesTable';
import PriorEntriesTable from './PriorEntriesTable';
import { useState } from 'react';
import DocumentBrowser from '../../../components/document-browser/DocumentBrowser';
import CimplicoStaffGuard from '../../../components/cimplico-staff-guard/CimplicoStaffGuard';

type EntriesProps = {
    worksheet: ReconciliationWorksheet | GenericWorksheet;
    priorWorksheet?: ReconciliationWorksheet | GenericWorksheet;
};

function Entries({ worksheet, priorWorksheet }: EntriesProps): JSX.Element {
    const [sort, setSort] = useState<string>('');

    // Get entries
    const entriesQuery = useEntriesV2(worksheet.id, { sort });

    if (entriesQuery.isLoading) {
        return (
            <div className="flex-1 h-full flex items-center justify-center">
                <Spinner />
            </div>
        );
    }

    if (!entriesQuery.isSuccess || entriesQuery.isError || !entriesQuery.data) {
        return <div className="flex-1 h-full flex items-center justify-center">Something went wrong!</div>;
    }

    const { data: entries } = entriesQuery.data;

    return (
        <>
            <DocumentBrowser locationSaveKey="browser-pos" />
            <EntriesTable worksheet={worksheet} entries={entries} onSort={setSort} isSorting={Boolean(sort)} />
            <CimplicoStaffGuard>
                {priorWorksheet && priorWorksheet.entries.length > 0 && (
                    <PriorEntriesTable priorWorksheet={priorWorksheet} currentWorksheet={worksheet} sort={sort} />
                )}
            </CimplicoStaffGuard>
        </>
    );
}

export default Entries;
